import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    marginBottom: 60,
  },

  logo: {
    width: 140,
  },

  logoInova: {
    width: 70,
  },
  
  logoDimensa: {
    width: 100,
  },

  
  titleContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '2rem',
    '& h2': {
      fontSize: "1.8rem",
      fontFamily: 'sans-serif',
      fontStyle: 'italic',
    },  
  },

  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    margin: 10,
    width: 220,

    '& > span': {
      fontSize: 14,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },

  drawerOpen: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },

  menuItem: {
    fontSize: '18px !important',
    color: '#000 !important',

    '&.Mui-selected': { 
      color: "#ffffff !important",
      backgroundColor: `${Colors.primaryColor} !important`,
    },
  },
  outButton: {
    backgroundColor: Colors.headerColor,
  },
}))

export default styles
